const SourceTypes = {
    POOL: "palette_pool",
    TILE: "cell_pool"
};

export default SourceTypes;
